import { render } from "./articleRight.vue?vue&type=template&id=b81630b4&scoped=true"
import script from "./articleRight.vue?vue&type=script&lang=js"
export * from "./articleRight.vue?vue&type=script&lang=js"

import "./articleRight.vue?vue&type=style&index=0&id=b81630b4&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81630b4"]])

export default __exports__